import React from 'react';
import Button from '@mui/material/Button';
import { determineAppEnvironment } from "../EzEnviornmentInfo/EzEnviornmentInfo";
import '../../ezclocker-colors.scss';
import './MainFeaturesSection.scss';
import online_schedule_img from "../../assets/images/online-schedule-img.jpg"


export default class MainFeaturesSection extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            redirectDomain: determineAppEnvironment()
        }
    }

    render() {
        return (
            <div
                className="main-features-section">
                <div
                    className="main-feature-card">
                    <div
                        className="clock-in-out-image-container">
                        <img
                            className="clock-in-out-image"
                            src={`${this.state.redirectDomain}/public/images/newLandingPage/shutterStock.png`}
                            alt="clock in/out" />
                    </div>
                    <div
                        className="main-feature-card-content">
                        <h1
                            className="main-feature-card-title">
                            Clock In/Out Anywhere
                        </h1>
                        <div
                            className="main-feature-card-details">
                            <p>
                                Employees can clock in using their own mobile device with a touch of a button and it works on both Apple and Android devices. No
                                need to spend money on expensive equipment. Our app’s simple design makes it easy for any employee, even the non-tech savvy ones
                                to use it.
                            </p>
                        </div>
                        <Button
                            variant="text"
                            className="main-feature-learn-more-button"
                            onClick={() => window.location.href = `${this.state.redirectDomain}/time-tracking/mobile-time-clock-apps/index.html`}>
                            Learn more
                        </Button>
                    </div>
                    <div
                        className="main-feature-card-image-container">
                        <img
                            className="main-feature-card-image left-orange-bar"
                            src={`${this.state.redirectDomain}/public/images/newLandingPage/shutterStock.png`}
                            alt="clock in/out" />
                    </div>
                </div>

                <div
                    className="main-feature-card">
                    <div
                        className="gps-verification-image-container">
                        <img
                            className="gps-verification-image"
                            src={`${this.state.redirectDomain}/public/images/newLandingPage/map_screen.png`}
                            alt="gps" />
                    </div>
                    <div
                        className="main-feature-card-image-container">
                        <img
                            className="main-feature-card-image right-orange-bar"
                            src={`${this.state.redirectDomain}/public/images/newLandingPage/map_screen.png`}
                            alt="gps" />
                    </div>
                    <div
                        className="main-feature-card-content">
                        <h1
                            className="main-feature-card-title">
                            GPS Verification
                        </h1>
                        <div
                            className="main-feature-card-details">
                            <p>
                                The GPS stamp automatically saves employees’ locations whenever they clock in or out so you can verify they are at the correct
                                location. No need to drive to each location or hire supervisors to ensure your employees are at the jobsite.
                            </p>
                        </div>
                        <Button
                            variant="text"
                            className="main-feature-learn-more-button"
                            onClick={() => window.location.href = `${this.state.redirectDomain}/time-tracking/gps-mobile-app/index.html`}>
                            Learn more
                        </Button>
                    </div>
                </div>

                <div
                    className="main-feature-card">
                    <div
                        className="online-scheduling-image-container">
                        <img
                            className="online-scheduling-image"
                            src={`${this.state.redirectDomain}/public/images/newLandingPage/shutterStock_2.png`}
                            alt="scheduleing" />
                    </div>
                    <div
                        className="main-feature-card-content">
                        <h1
                            className="main-feature-card-title">
                            Online Scheduling
                        </h1>
                        <div
                            className="main-feature-card-details">
                            <p>
                                Tired of emailing or texting your employees their schedule? Or do you consistently need to make last minute changes? Our online
                                scheduling tool will make your life easier. Schedule your employees using our website or mobile app. Employees will get notified
                                on their phone that they have a new schedule. No more missed shifts.
                            </p>
                        </div>
                        <Button
                            variant="text"
                            className="main-feature-learn-more-button"
                            onClick={() => window.location.href = `${this.state.redirectDomain}/time-tracking/employee-scheduling-software/index.html`}>
                            Learn more
                        </Button>
                    </div>
                    <div
                        className="main-feature-card-image-container">
                        <img
                            className="main-feature-card-image left-orange-bar"
                            src={online_schedule_img}
                            alt="scheduleing" />
                    </div>
                </div>
            </div >);
    }
}
